import { formatWeight } from "../../../utils/numberUtils";
import type { CashDeploymentMode } from "../../../utils/cashDeploymentSettings";

export type ExplainerPhase = "start" | "deposit" | "settle" | "complete";

export interface AllocationSnapshot {
  nlv: number;
  productDollars: number;
  cashDollars: number;
  productPct: number;
  cashPct: number;
}

export const EXPLAINER_START_NLV = 100_000;
export const EXPLAINER_DEPOSIT = 20_000;
export const EXPLAINER_PRODUCT_LABEL = "Invested";
export const EXPLAINER_TARGET_PRODUCT_PCT = 50;
export const EXPLAINER_TARGET_CASH_PCT = 50;

export const EXPLAINER_PHASE_ORDER: ExplainerPhase[] = ["start", "deposit", "settle", "complete"];

export const EXPLAINER_PHASE_LABELS: Record<ExplainerPhase, string> = {
  start: "Before deposit",
  deposit: "Deposit arrives",
  settle: "Setting applies",
  complete: "After deposit",
};

const START: AllocationSnapshot = {
  nlv: EXPLAINER_START_NLV,
  productDollars: 50_000,
  cashDollars: 50_000,
  productPct: EXPLAINER_TARGET_PRODUCT_PCT,
  cashPct: EXPLAINER_TARGET_CASH_PCT,
};

const FINAL: Record<CashDeploymentMode, AllocationSnapshot> = {
  "auto-deploy": {
    nlv: EXPLAINER_START_NLV + EXPLAINER_DEPOSIT,
    productDollars: 60_000,
    cashDollars: 60_000,
    productPct: EXPLAINER_TARGET_PRODUCT_PCT,
    cashPct: EXPLAINER_TARGET_CASH_PCT,
  },
  reserve: {
    nlv: EXPLAINER_START_NLV + EXPLAINER_DEPOSIT,
    productDollars: 50_000,
    cashDollars: 70_000,
    productPct: 41.67,
    cashPct: 58.33,
  },
};

export function formatExplainerSplitLabel(productPct: number, cashPct: number): string {
  return `${formatWeight(productPct, 0)}% invested / ${formatWeight(cashPct, 0)}% cash`;
}

export function getExplainerSnapshot(mode: CashDeploymentMode, phase: ExplainerPhase): AllocationSnapshot {
  if (phase === "start") return START;

  if (phase === "deposit") {
    return {
      nlv: EXPLAINER_START_NLV + EXPLAINER_DEPOSIT,
      productDollars: START.productDollars,
      cashDollars: START.cashDollars + EXPLAINER_DEPOSIT,
      productPct: (START.productDollars / (EXPLAINER_START_NLV + EXPLAINER_DEPOSIT)) * 100,
      cashPct: ((START.cashDollars + EXPLAINER_DEPOSIT) / (EXPLAINER_START_NLV + EXPLAINER_DEPOSIT)) * 100,
    };
  }

  return FINAL[mode];
}

export const EXPLAINER_FINAL = FINAL;
